import { AloftArea, AloftPrice, AloftPriceJSON } from '@aloft/toolkit-shared';

import { createAppAsyncThunk } from '../../createAppAsyncThunk.ts';
import { SubjectPropertyDataState } from '../../types.ts';

export const setPerSf = createAppAsyncThunk(
  'opinionOfSiteValue/setPerSf',
  (perSf: AloftPriceJSON, { getState, rejectWithValue }) => {
    const { propertyData } = getState();
    const subjectEditableData = (propertyData.entities.subject as SubjectPropertyDataState)
      .subjectData.editableData;

    const { opinionOfSiteValue } = subjectEditableData;
    const { area } = subjectEditableData.site;

    const siteValue = area
      ? AloftPrice.schema.parse(perSf).mul(AloftArea.schema.parse(area).getUnitAmount('sqft'))
      : AloftPrice.zero;

    const currentSiteValue = AloftPrice.schema.parse(opinionOfSiteValue);
    if (siteValue.equals(currentSiteValue)) {
      return rejectWithValue({ siteValue: currentSiteValue.toJSON() });
    }

    return siteValue.toJSON();
  },
);
